
import TitleBox from '@/components/CSS/TitleBox'
import getPageTitle from '@/utils/get-page-title'

export default {
	components: {
		TitleBox
	},
	data() {
		return {
			title: '相关授权书',
			leftImg: 'https://oss.pzds.com/app-h5/image/773626878937e651617833d7fa371834.png'
		}
	},
	mounted() {
		this.getPageData()
		document.addEventListener('contextmenu', function (e) {
			e.preventDefault()
		})
	},
	beforeDestroy() {
		document.removeEventListener('contextmenu', function (e) {
			e.preventDefault()
		})
	},
	methods: {
		back() {
			this.$router.go(-1)
		},
		getPageData() {
			document.title = getPageTitle(this.title)
		}
	}
}
